import { render, staticRenderFns } from "./A3.vue?vue&type=template&id=02d5becd&"
import script from "./A3.vue?vue&type=script&lang=ts&"
export * from "./A3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports